module.exports = __webpack_public_path__ + "img/p3-xyz2.a8a4ea7a.svg";